"use client";

import { createContext, useContext } from "react";

type TenantData = {
  profile: any;
  community: any;
};

const TenantContext = createContext<TenantData | null>(null);

export function useTenant() {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error("useTenant must be used within TenantProvider");
  return ctx;
}

/** Use tenant context when available (e.g. public routes like /logout). Returns null when outside TenantProvider. */
export function useTenantOptional() {
  return useContext(TenantContext);
}

export function TenantProvider({
  children,
  profile,
  community,
}: {
  children: React.ReactNode;
  profile: any;
  community: any;
}) {
  return (
    <TenantContext.Provider value={{ profile, community }}>
      {children}
    </TenantContext.Provider>
  );
}
